import { render, staticRenderFns } from "./TaskCertificate.vue?vue&type=template&id=df8c8738"
import script from "./TaskCertificate.vue?vue&type=script&lang=js"
export * from "./TaskCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports